import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import {
    DragDropContext,
    Droppable,
    Draggable
} from 'react-beautiful-dnd'

import Button from 'components/button/button'

import { connect } from 'react-redux'

import copy from 'fast-copy'
import { doSort, ucfirst } from 'utils'
import { times } from 'lodash'

import Radio from 'components/input/radio'

import ContentEditable from 'react-contenteditable'

import { saveColumnData } from 'state/actions'

import {
    getCurrentUser,
} from 'state/selectors'

import ControlsLikeContainer from 'components/controls-like-container/controls-like-container'
import DragHandle from 'components/drag-handle/drag-handle'

import InputStandard from 'components/input/standard'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import moment from 'moment'

const availableColumns = [
    {
        title: 'People',
        type: 'PEOPLE'
    }, {
        title: 'Status',
        type: 'STATUS'
    }, {
        title: 'Date',
        type: 'DATE'
    }, {
        title: 'Text',
        type: 'TEXT'
    }, {
        title: `Link`,
        type: 'LINK'
    }
]

class ModalCustomiseProject extends Component {
    state = {
        formValues: {
            type: availableColumns[0].type,
            title: ''
        },
        columns: this.props.data.columns
    }

    inputRefs = {}
    maximumCapacity = false

    componentWillMount() {
        this.portal = document.createElement('div')
        this.portal.classList.add('column-list', 'destination')

        document.body.appendChild(this.portal)
    }

    updateColumns = columns => {
        this.setState({
            columns
        })
    }

    handleSubmit = e => {
        e.preventDefault()

        const { type, title } = this.state.formValues

        if (type && title) {
            this.addColumn(type, title)

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    title: ''
                }
            })
        }
    }

    addColumn = (type, name) => {
        if (this.maximumCapacity) {
            this.props.handleError(`You can only have a maximum of 8 columns in a project.`)
            return
        }

        const columns = [...this.state.columns]

        let tempId = -1
        let order = 1

        columns.forEach(column => {
            if (column.id <= tempId) {
                tempId = (column.id - 1)
            }

            if (column.order >= order) {
                order = (column.order + 1)
            }
        })

        let finalColumnName = null
        let isColumnNameCustom = !availableColumns.find(column => column.title === name)
        let existingColumnOfTypeIndex = 0

        while (!finalColumnName) {
            let nameToTest = name

            if (existingColumnOfTypeIndex) {
                nameToTest += ' ' + (existingColumnOfTypeIndex + 1)
            }

            if (columns.find(column => {
                return (column.custom_name === nameToTest || column.type === nameToTest.toUpperCase())
            })) {
                existingColumnOfTypeIndex++
            } else {
                finalColumnName = nameToTest

                if (existingColumnOfTypeIndex) {
                    isColumnNameCustom = true
                }
            }
        }

        const newColumn = {
            id: tempId,
            type,
            order,
            custom_name: isColumnNameCustom ? finalColumnName : null,
            is_primary: false
        }

        columns.push(newColumn)

        this.updateColumns(columns)
    }

    // I assume this is repeated elsewhere.
    getColumnTypeName = type => {
        switch (type) {
            case 'NAME':
                return 'Task name'
            default:
                return type ? type.charAt(0).toUpperCase() + type.slice(1).toLowerCase() : ''
        }
    }

    getColumnsWithPinned = _ => {
        const {
            has_timing,
        } = this.props.data

        const { columns } = this.state

        const columnsWithPinned = [...columns]

        columnsWithPinned.unshift({
            id: 0,
            type: 'NAME',
            order: -1,
            disabled: true
        })

        if (has_timing) {
            columnsWithPinned.push({
                id: 0,
                type: 'TIMING',
                order: 999,
                disabled: true
            })
        }

        return columnsWithPinned
    }

    onDragEnd = result => {
        if (result.destination) {
            const { columns } = this.state

            let draggedColumn = null

            const columnInfo = result.draggableId.split('_')

            columns.forEach(column => {
                if (column.type == columnInfo[0] && column.id == parseInt(columnInfo[1])) {
                    draggedColumn = column
                }

            })

            const originalIndex = (result.source.index - 1)
            const newIndex = (result.destination.index - 1)

            const updatedColumns = copy(doSort(columns, 'number', 'order'))

            updatedColumns.splice(originalIndex, 1)

            updatedColumns.splice(newIndex, 0, draggedColumn)

            updatedColumns.forEach((column, key) => {
                if (column.order >= 0 && column.order < 999) {
                    updatedColumns[key].order = key
                }

            })

            this.updateColumns(updatedColumns)
        }
    }

    editColumn = (column, currentValue) => {
        this.setState({
            currentlyEditedColumnId: column.id,
            tempColumnName: currentValue
        })

        const inputRef = this.inputRefs[column.id]

        if (inputRef) {
            setTimeout(_ => {
                inputRef.htmlEl.focus()
            }, 1)
        }
    }

    deleteColumn = column => {
        const columns = [...this.state.columns]

        const indexToRemove = columns.findIndex(tempColumn => {
            return tempColumn.id == column.id
        })

        columns.splice(indexToRemove, 1)

        this.updateColumns(columns)
    }

    updateText = value => {
        this.setState({
            tempColumnName: value
        })
    }

    saveColumn = _ => {
        const {
            tempColumnName,
            currentlyEditedColumnId
        } = this.state

        if (tempColumnName) {
            const columns = copy(this.state.columns)

            columns.forEach((column, index) => {
                if (column.id == currentlyEditedColumnId) {
                    columns[index].custom_name = tempColumnName
                }
            })

            this.updateColumns(columns)
        }

        const inputRef = this.inputRefs[currentlyEditedColumnId]

        if(inputRef){
            this.inputRefs[currentlyEditedColumnId].htmlEl.scrollLeft = 0
        }

        this.setState({
            tempColumnName: null,
            currentlyEditedColumnId: null
        })
    }

    cancelEdit = _ => {
        const {
            currentlyEditedColumnId
        } = this.state

        const inputRef = this.inputRefs[currentlyEditedColumnId]

        if(inputRef){
            this.inputRefs[currentlyEditedColumnId].htmlEl.scrollLeft = 0
        }

        this.setState({
            tempColumnName: null,
            currentlyEditedColumnId: null
        })
    }

    hasSeveral = type => {
        const {
            columns
        } = this.state

        let typeCount = 0

        columns.forEach(column => {
            if (column.type == type) {
                typeCount++
            }
        })

        return typeCount > 1
    }

    setPrimary = column => {
        const columns = copy(this.state.columns)

        columns.forEach(loopedColumn => {
            if (loopedColumn.type == column.type) {
                loopedColumn.is_primary = loopedColumn.id == column.id
            }
        })

        this.updateColumns(columns)
    }

    componentDidUpdate = _ => {
        const {
            columns
        } = this.state

        const validatedColumnTypes = []
        let indexToMakePrimary = -1

        columns.forEach((column, index) => {
            if (!column.is_primary && !validatedColumnTypes.includes(column.type)) {
                let noPrimaryColumnsOfType = true

                columns.forEach(loopedColumn => {
                    if (loopedColumn.type === column.type && loopedColumn.is_primary) {
                        noPrimaryColumnsOfType = false
                    }
                })

                if (noPrimaryColumnsOfType && indexToMakePrimary == -1) {
                    indexToMakePrimary = index
                }

                validatedColumnTypes.push(column.type)
            }
        })

        if (indexToMakePrimary !== -1) {
            const clonedColumns = copy(columns)

            clonedColumns[indexToMakePrimary].is_primary = true

            this.updateColumns(clonedColumns)
        }
    }

    canPrimary = type => {
        switch (type) {
            case 'TEXT':
            case 'LINK':
                return false
            default:
                return true
        }
    }

    handleChange = (key, value) => {
        const _formValues = { ...this.state.formValues }

        _formValues[key] = value

        this.setState({
            formValues: _formValues
        })
    }

    handleSave = () => {
        const { saveColumnData, data, setLoading, handleSuccess } = this.props
        const { columns } = this.state

        setLoading(true)

        saveColumnData(data.id, columns, response => {
            setLoading(false)

            handleSuccess(`Success! We've updated your columns.`)
        })
    }

    render() {
        const {
            data,
            allMilestones,
            currentUser
        } = this.props

        const {
            columns
        } = this.state

        let columnsWithPinned = this.getColumnsWithPinned()

        columnsWithPinned = doSort(columnsWithPinned, 'number', 'order')

        this.maximumCapacity = columns.length >= 6

        const {
            formValues,
            currentlyEditedColumnId,
            tempColumnName
        } = this.state

        const firstMilestoneName = (() => {
            const firstMilestone = (allMilestones && data.milestones && data.milestones.length) ? allMilestones[data.milestones[0]] : null

            if (firstMilestone) {
                return firstMilestone.name
            }

            return `Milestone name`
        })()

        const showPrimaryRow = (() => {
            let anyHaveSeveral = false

            columns.some(column => {
                if (this.hasSeveral(column.type)) {
                    anyHaveSeveral = true
                    return true
                }
            })

            return anyHaveSeveral
        })()

        return (
            <div className={'has-tabs'}>
                <div className="modal-tabs-heading">
                    <h2>
                        Customize project
                    </h2>
                </div>
                <ValidateResponse dismissCallback={this.props.handleDismiss} response={this.props.validateResponse} />
                <form onSubmit={this.handleSubmit}>
                    <div>
                        <label className={'form-label'}>
                            Add a new column:
                        </label>
                        <InputStandard
                            outlineOnFocus={true}
                            ref={ref => this.inputRef = ref}
                            value={formValues.title || ''}
                            onChange={e => { this.handleChange('title', e.target.value) }}
                            placeholder={ucfirst(formValues.type.toLowerCase())}
                        />
                    </div>
                    <div>
                        <label className={'form-label'}>
                            Column type:
                        </label>
                        <DropdownMenu
                            isObjects={true}
                            selectableItems={availableColumns.map(({
                                title, type
                            }) => {
                                return {
                                    id: type,
                                    name: title
                                }
                            })}
                            selectedItemId={formValues.type || null}
                            handleChange={value => this.handleChange('type', value)}
                            parentType="type"
                        />
                    </div>
                    <div>
                        <label className={'form-label'}>
                            &nbsp;
                        </label>
                        <Button
                            icon={'fe-plus'}
                            label={''}
                            level={'x-low'}
                            disabled={!formValues.title}
                        />
                    </div>
                </form>
                <label className={'form-label'}>
                    Edit or re-order your existing columns:
                </label>
                <div className="milestone">
                    <DragDropContext onDragStart={this.cancelEdit} onDragEnd={this.onDragEnd}>
                        <Droppable
                            droppableId={'organisations'}
                            type="COLUMN"
                            direction={'horizontal'}
                        >
                            {provided => (
                                <ul
                                    className="column-list destination"
                                    ref={provided.innerRef}
                                >
                                    {columnsWithPinned.map((column, index) => {
                                        return (
                                            <Draggable
                                                index={index}
                                                key={column.type + '_' + column.id}
                                                draggableId={column.type + '_' + column.id}
                                                type="COLUMN"
                                                isDragDisabled={column.disabled}
                                            >
                                                {(provided, snapshot) => {
                                                    const originalColumnName = this.getColumnTypeName(column.type)
                                                    let columnName = column.custom_name ? column.custom_name : originalColumnName

                                                    const isBeingEdited = currentlyEditedColumnId == column.id

                                                    if (isBeingEdited) {
                                                        columnName = tempColumnName
                                                    }

                                                    if (column.type === 'NAME') {
                                                        columnName = firstMilestoneName
                                                    }

                                                    let className = column.type

                                                    const columnWidth = (() => {
                                                        let _width = 130

                                                        switch (column.type) {
                                                            case 'TIMING':
                                                                _width = 90
                                                                break
                                                            case 'NAME':
                                                                _width = 200
                                                        }

                                                        return _width
                                                    })()

                                                    if (column.disabled) {
                                                        className += ' disabled'
                                                    }

                                                    if (snapshot.isDragging) {
                                                        className += ' is-dragging'
                                                    }

                                                    if (isBeingEdited) {
                                                        className += ' editing'
                                                    }

                                                    if (columnName != originalColumnName) {
                                                        className += ' show-type-indicator'
                                                    }

                                                    const innerTaskContent = (() => {
                                                        switch (column.type) {
                                                            case 'NAME':
                                                                return (
                                                                    <span>
                                                                        Task name
                                                                    </span>
                                                                )
                                                            case 'PEOPLE':
                                                                return (
                                                                    <span>
                                                                        <img src={`/images/profile-empty${(currentUser && currentUser.show_dark_ui) ? '' : '-light'}.jpg`} />
                                                                        <span>
                                                                            Me
                                                                        </span>
                                                                    </span>
                                                                )
                                                            case 'DATE':
                                                                return (
                                                                    <span>
                                                                        { moment().format('MMMM Do')}
                                                                    </span>
                                                                )
                                                            case 'STATUS':
                                                                return (
                                                                    <span>
                                                                        <i className={'fa fa-check'} />
                                                                        <span>
                                                                            Complete
                                                                        </span>
                                                                    </span>
                                                                )
                                                            case 'TIMING':
                                                                return (
                                                                    <span>
                                                                        <span>
                                                                            5:00
                                                                        </span>
                                                                        <i className={'fe fe-clock'} />
                                                                    </span>
                                                                )
                                                            case 'TEXT':
                                                                return (
                                                                    <span>
                                                                        Hello!
                                                                    </span>
                                                                )
                                                            case 'LINK':
                                                                return (
                                                                    <span>
                                                                        hassl.co
                                                                    </span>
                                                                )
                                                        }
                                                    })()

                                                    const hasSeveral = this.hasSeveral(column.type)

                                                    const listItem = (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={className}
                                                        >
                                                            <li style={{
                                                                width: columnWidth + 'px'
                                                            }}>
                                                                <div className={'title-row'}>
                                                                    { !column.disabled ?
                                                                        <DragHandle />
                                                                    : null }
                                                                    <ContentEditable
                                                                        onChange={e => this.updateText(e.target.value)}
                                                                        html={columnName}
                                                                        disabled={!isBeingEdited}
                                                                        onKeyPress={e => { (e.key === 'Enter' ? this.saveColumn() : null) }}
                                                                        ref={ref => this.inputRefs[column.id] = ref}
                                                                    />
                                                                    {!column.disabled ?
                                                                        <ControlsLikeContainer
                                                                            canEdit={true}
                                                                            isEditing={isBeingEdited}
                                                                            editCallback={_ => this.editColumn(column, columnName)}
                                                                            deleteCallback={_ => this.deleteColumn(column)}
                                                                            saveCallback={this.saveColumn}
                                                                            cancelCallback={this.cancelEdit}
                                                                        />
                                                                        : null}
                                                                </div>
                                                                <div className={'set-primary-row'}>
                                                                    <React.Fragment>
                                                                        {showPrimaryRow ?
                                                                            <div className={hasSeveral ? 'primary-radio visible' : "primary-radio"}>
                                                                                <label className={'tooltip-trigger'}>
                                                                                    <Radio
                                                                                        name={originalColumnName}
                                                                                        onChange={_ => { this.setPrimary(column) }}
                                                                                        checked={column.is_primary}
                                                                                    />
                                                                                    <span>
                                                                                        {column.is_primary ? 'Primary' : 'Secondary'}
                                                                                    </span>
                                                                                    <div className={'tooltip'}>
                                                                                        Set your primary '{ucfirst(column.type.toLowerCase())}' column.<br />
                                                                                        This is used for stats and reporting.
                                                                                    </div>
                                                                                </label>
                                                                            </div>
                                                                            : null}
                                                                    </React.Fragment>
                                                                </div>
                                                                <ul className={`tasks-list ${column.type}`}>
                                                                    {times(1, _index => {
                                                                        return (
                                                                            <li key={_index}>
                                                                                { innerTaskContent}
                                                                            </li>
                                                                        )
                                                                    })}
                                                                </ul>
                                                            </li>
                                                            {provided.placeholder}
                                                        </div>
                                                    )

                                                    if (snapshot.isDragging) {
                                                        return ReactDOM.createPortal(listItem, this.portal)
                                                    } else {
                                                        return listItem
                                                    }
                                                }}
                                            </Draggable>
                                        )
                                    })}
                                    {provided.placeholder}
                                </ul>
                            )
                            }
                        </Droppable>
                    </DragDropContext>
                    <React.Fragment>
                        <Button
                            size={'big'}
                            level={'high'}
                            callback={this.handleSave}
                            label={`Update columns`}
                            icon={'check'}
                            disabled={this.isOverQuota}
                        />
                        <Button
                            size={'big'}
                            level={'low'}
                            callback={this.props.closeCallback}
                            label={'Cancel'}
                        />
                    </React.Fragment>
                </div>
            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
        allMilestones: state.account.entities.milestones,
        currentUser: getCurrentUser(state)
    }
}

const ModalCustomiseProjectWithValidateResponse = withValidateResponse(ModalCustomiseProject)

export default connect(mapStateToProps, {
    saveColumnData
})(ModalCustomiseProjectWithValidateResponse)


// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-customise-project.jsx